export const COURIER_AUTHENTICATION_TYPE = {
  BRANCH_KEY: 'branch_key',
  GLOBAL_KEY: 'global_key',
  SINGLE_KEY: 'single_key',
};
